import type { AdminMeResponse } from '@diana/contracts';
import { createContext, useContext, type PropsWithChildren } from 'react';

type ShellPublishing = {
  user: AdminMeResponse['user'];
  pendingCount: number;
  pendingLoading: boolean;
  publishing: boolean;
  openPublish(): void;
  logout(): void;
};

const ShellPublishingContext = createContext<ShellPublishing | null>(null);

export function ShellPublishingProvider({
  value,
  children,
}: PropsWithChildren<{ value: ShellPublishing }>) {
  return (
    <ShellPublishingContext.Provider value={value}>{children}</ShellPublishingContext.Provider>
  );
}

export function useShellPublishing() {
  const context = useContext(ShellPublishingContext);
  if (!context) throw new Error('Site publishing controls require the connected shell');
  return context;
}
